<template>
  <div class="c-app flex-row align-items-center">
    <div v-if="submitted" class="loader">
      <CSpinner
        style="width:3rem;height:3rem;"
        color="primary"
        grow
      />
    </div>
    
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="8">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <CForm>
                  <h1>Reset Password</h1>
                  <p class="text-muted">Please type your registered email to reset password</p>
                  <CInput
                    placeholder="Email"
                    autocomplete="username email"
                    name="email"
                    v-model="form.email"
                    v-validate="{required: true, min: 5, email: true}"
                  >
                    <template #prepend-content><CIcon name="cil-user"/></template>
                  </CInput>
                  <div v-if="errors" class="error_msg">
                    {{errors.first('email')}}
                  </div>
                  <CRow class="mt-3">
                    <CCol col="12" class="text-center">
                      <CButton color="primary" class="px-4" @click="Login">Send Password Reset Link</CButton>
                    </CCol>
                  </CRow>

                  <!-- Custimoo staff: a Microsoft password is reset at Microsoft,
                       not here. Week 1 keeps the portal reset above too, so anyone
                       still on a portal password can use it. -->
                  <CRow v-if="isCustimooEmail" class="mt-3">
                    <CCol col="12" class="text-center">
                      <p class="text-muted mb-2" style="font-size:.85rem;">
                        Custimoo accounts sign in with Microsoft — reset that password at Microsoft:
                      </p>
                      <CButton color="secondary" variant="outline" class="px-4" @click="ssoReset">
                        Reset Custimoo Password
                      </CButton>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import {handleResponseException, handleUserLoginLogOutAction} from "@/helpers/Helpers";
import {noTokenRequest} from "@/config/httpCommon"
import Store from "../../store";

export default {
  name: 'ForgotPassword',
  data(){
    return{
      form:{
        email: '',
      },
      submitted: false,
    }
  },
  computed: {
    // Mirror the login page: a @custimoo.com email gets the Microsoft reset option.
    isCustimooEmail(){
      return /@custimoo\.com\s*$/i.test((this.form.email || '').trim());
    },
  },
  methods: {
    // A Microsoft (M365) password is managed by Microsoft, not this app, so send
    // staff to Microsoft's self-service reset (SSPR), pre-filled with their email.
    // Requires SSPR to be enabled in the Entra tenant.
    ssoReset(){
      const email = encodeURIComponent((this.form.email || '').trim());
      window.location.href = 'https://passwordreset.microsoftonline.com/?username=' + email;
    },
    async Login(){
      let valid = await this.$validator.validate();
      if(valid){
        this.submitted = true;
        let form_data = {
          email: this.form.email
        }
       await noTokenRequest.post("forgot-password", form_data).then(async successResponse => {
         let response_data = successResponse.data;
         if(response_data.success) {
           this.showToast('Email sent to reset your password', 'SUCCESS');
         } else {
           this.showToast('Not a valid email', 'ERROR');
         }
         this.submitted = false;
        }).catch(error => {
         this.submitted = false;
         this.showToast('Not a valid email', 'ERROR');
        });
      }
    }
  }
}
</script>
<style scoped>
    .form-group {
      margin: 1rem 0 0 0;
    }
    .input-group-prepend {
      background-color: transparent;
      padding: 0;
      color: #fff;
      padding-top: 0;
    }
</style>
